module.exports = __webpack_public_path__ + "static/media/logout.fbf92387.svg";